// Vendor Imports
//import $ from 'jquery';
//import Scrollify from 'jquery-scrollify';

// Element Class Imports
import Utilities from './materials/atoms/01-helpers/utilities';
import Grid from './materials/atoms/13-grid/grid';
import Form from './materials/atoms/form/form';
import Accordion from './materials/molecules/accordion/accordion';
import Header from './materials/organisms/header/header';
import Footer from './materials/organisms/footer/footer';
import Map from './materials/molecules/map/map';
import SearchNav from './materials/molecules/search-nav/search-nav';
import ThemesModal from './materials/molecules/themes-modal/themes-modal';
import Tab from './materials/molecules/tab/tab';
import Dropdown from './materials/molecules/dropdown/dropdown';
import Slider from './materials/molecules/slider/slider';
import FooterLanguage from './materials/molecules/footer/footer-language';
import Video from './materials/molecules/video/video';
import CategoryOverview from './materials/molecules/category-overview/category-overview';
import BackToTop from './materials/molecules/back-to-top/back-to-top';
import MediaTeaser from './materials/molecules/media-teaser/media-teaser';
import EmptyColumn from './materials/molecules/empty-column/empty-column';
import ArticleHeader from './materials/molecules/article-header/article-header';
import PageHeader from './materials/molecules/page-header/page-header';
// Custom scripts
// https://www.npmjs.com/package/css-element-queries
const EQ = require('../node_modules/css-element-queries/src/ElementQueries');
/* eslint-disable */
const Waypoint = require('../node_modules/waypoints/lib/noframework.waypoints.js');
/* eslint-enable */
const objectFitImages = require('object-fit-images');

function ready(fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(() => {
  const html = document.querySelector('html');
  const Streusel = window.Streusel || {};
  // Init polyfill object-fit-images
  objectFitImages();

  html.classList.remove('no-js');

  // New js definitions without forced class mapper
  Utilities.init();
  Form.init();
  Grid.init();

  Streusel.Accordion = Accordion.init();
  Streusel.Header = Header.init();
  Streusel.Footer = Footer.init();
  Streusel.Map = Map.init();
  Streusel.SearchNav = SearchNav.init();
  Streusel.ThemesModal = ThemesModal.init();
  Streusel.Tab = Tab.init();
  Streusel.Dropdown = Dropdown.init();
  Streusel.Slider = Slider.init();
  Streusel.FooterLanguage = FooterLanguage.init();
  Streusel.Video = Video.init();
  Streusel.CategoryOverview = CategoryOverview.init();
  Streusel.BackToTop = BackToTop.init();
  Streusel.MediaTeaser = MediaTeaser.init();
  Streusel.EmptyColumn = EmptyColumn.init();
  Streusel.ArticleHeader = ArticleHeader.init();
  Streusel.PageHeader = PageHeader.init();

  EQ.init();
});



// WEBPACK FOOTER //
// ./src/application.js